import axios from 'axios';
import Page from '../../lib/page';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function updateBnaData(articleInfo) {
  return () => {
    if (Page.isLoggedIn()) {
      const {
        bnaListId = '',
        bnaId = '',
        intentId = '',
        intentPromptedTime = '',
      } = articleInfo.channelDetails || {};
      if (bnaListId && bnaId && intentId && intentPromptedTime) {
        return axios.post('/smarthelp/update-bna-data', {
          _csrf: Page.getCSRFtoken(),
          bnaListId,
          bnaId,
          intentId,
          intentPromptedTime,
        });
      }
    }
    return undefined;
  };
}

module.exports = {
  updateBnaData,
};



// WEBPACK FOOTER //
// ./home/actions/action-update-bna-data.js